/**
 * Shared mutable state for the Potree library.
 *
 * This module exists to break circular imports between Potree.js and
 * Potree_update_visibility.ts. Both modules need access to these values,
 * and Potree.js re-exports them for external consumers.
 */

import * as THREE from 'three';
import { LRU } from './LRU';

export const lru = new LRU();

export let pointBudget = 1 * 1000 * 1000;
export let framenumber = 0;
export let numNodesLoading = 0;
export const maxNodesLoading = 12;
export let pointLoadLimit = 2 * 1000 * 1000;
export let projectId = '';
// Blob container the project's point clouds are fetched from. Not the project id: a duplicated
// project shares its source's container.
export let storageContainer = '';
export let isLocalProject = false;
export let storageBaseUrl = '';

export function setProjectId(value: string) {
  projectId = value;
}

export function setStorageContainer(value: string) {
  storageContainer = value;
}

export function setIsLocalProject(value: boolean) {
  isLocalProject = value;
}

export function setStorageBaseUrl(value: string) {
  storageBaseUrl = value;
}
export let rendered_tiles: { [key: string]: boolean } = {};
export let loaded_tiles_network: { [key: string]: boolean } = {};

export const debug: {
  allowedNodes?: string[];
  message?: string;
  scale?: number;
  [key: string]: unknown;
} = {};

// Static path pointing to public/potree/potree/ where workers and resources are served
export const scriptPath = '/potree/potree';
export const resourcePath = scriptPath + '/resources';

export const stats: {
  loadTime: string;
  startRender: number;
  decodings: number[];
} = {
  loadTime: '',
  startRender: performance.now(),
  decodings: [],
};

// Used by Potree_update_visibility to track point cloud transform changes
export const _pointcloudTransformVersion: Map<unknown, { number: number; transform: THREE.Matrix4 }> = new Map();

export function setPointBudget(value: number) {
  pointBudget = value;
}

export function setFramenumber(value: number) {
  framenumber = value;
}

export function incrementNumNodesLoading() {
  numNodesLoading++;
}

export function decrementNumNodesLoading() {
  numNodesLoading--;
}

export function setNumNodesLoading(value: number) {
  numNodesLoading = value;
}

export function setPointLoadLimit(value: number) {
  pointLoadLimit = value;
}

export function resetRenderedTiles() {
  rendered_tiles = {};
}

export function resetLoadedTilesNetwork() {
  loaded_tiles_network = {};
}

export function resetStats() {
  stats.decodings = [];
  stats.loadTime = '';
}
